import React from 'react'

import { Loader, Icon } from 'semantic-ui-react'

const getIcon = (status) => {
  let res
  switch (status) {
    case 'ok':
      res = 'circle check'
      break
    case 'warning':
      res = 'circle exclamation'
      break
    case 'critical':
      res = 'triangle exclamation'
      break
    default:
      res = 'circle check'
  }
  return res
}

const StatsBarVertical = ({ isLoading, boxes, className, ...otherProps }) => (
  <div {...otherProps} className={`StatsBarVertical ${className || ''}`}>
    {boxes &&
      boxes.map((box, i) => <Box key={i} box={box} isLoading={isLoading} />)}
  </div>
)

const Box = ({ box, isLoading }) => (
  <div className={`Box ${box.status || 'ok'}${box.hidden ? ' hidden' : ''}`}>
    <div className='left-section'>
      <h4>{box.title}</h4>
      {isLoading ? <Loader active inline /> : <p>{box.description}</p>}
      {box.action && (
        <div className='footer'>
          <button className='link primary' onClick={box.action}>
            {box.actionTitle}
          </button>
          <Icon name='chevron right' />
        </div>
      )}
    </div>
    {box.status && (
      <div className='right-section'>
        <Icon name={getIcon(box.status)} />
      </div>
    )}
  </div>
)

export default StatsBarVertical
